import data from "../../../../../src/FilteredSearch.docs.json";
import * as React from 'react';
export default {
  data,
  React
};